// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-1Bq","textarea":"styles_textarea__3G743"};